import { useMemo } from 'react';
import { HeadingHelper, LevelType } from '../../heading-helper/heading-helper';
import { FaqItem } from './components/faq-item';

export type FaqClusterItem = {
    question: string;
    answer: TrustedHTML;
    textColor?: string;
};

export type FaqClusterProps = {
    questions: FaqClusterItem[];
    labels?: {
        headingText: string;
    };
    hideTitle?: boolean;
    headingLevel: LevelType;
    textColor: string;
};

export function FaqCluster({ questions, labels, hideTitle = false, headingLevel = 3, textColor = 'black' }: FaqClusterProps) {
    const textColorClass = useMemo(() => (textColor === 'black' ? 'r-text-black' : 'r-text-white'), [textColor]);
    if (!questions.length) {
        return null;
    }

    const showTitle = () => !hideTitle && labels?.headingText;

    return (
        <div data-component="faq-cluster" className={textColorClass}>
            {showTitle() && (
                <HeadingHelper level={headingLevel} classList="r-pb-4 r-text-3xl r-font-bold">
                    {labels?.headingText || ''}
                </HeadingHelper>
            )}
            <div>
                {questions.map((props, index) => (
                    <FaqItem {...props} key={index} index={index + 1} textColor={textColorClass} />
                ))}
            </div>
        </div>
    );
}
